<template>
  <div class="main-button">
    <cus-button
      v-for="(item, index) in actionBtns"
      :key="index"
      :text="item.label"
      :width="100"
      color="whiteBlue"
      :disabled="!checkDisabled(item.func)"
      :leftIcon="checkInfo(item.func) ? 'check-circle-fill' : ''"
      leftIconClass="green-icon"
      @click="handleClick(item.func)"
    ></cus-button>
    <cus-button
      text="交易"
      color="blue"
      topIcon="coin"
      topIconClass="big-top"
      :disabled="getStep === 1 || getCart?.length < 1"
      @click="payment"
      style="grid-area: 1/5/3/6"
    ></cus-button>
  </div>

  <!-- 各式彈窗 -->
  <component :is="dialogTemplate"></component>
  <MemberDialog v-model="showMemberDialog" caller="ActionButton" @checked="handleMemberChecked"></MemberDialog>
</template>
<script>
import { useDialog } from '@/utils/dialog';
import { defineAsyncComponent, reactive, watch, getCurrentInstance,  ref  } from 'vue';
import { useGetters, useMutations, useActions } from '@/utils/mapStore';
import { useRouter } from 'vue-router';
import {useStore} from "vuex";

export default {
  name: 'action-button',
  emits: ['open-member-dialog'],
  components: {
    Alert: defineAsyncComponent(() => import('@/components/dialog/Alert.vue')),
    MoreSelect: defineAsyncComponent(() => import('@/components/dialog/MoreSelect.vue')),
    InputInfo: defineAsyncComponent(() => import('@/components/dialog/InputInfo.vue')),
    Information: defineAsyncComponent(() => import('@/components/dialog/Information.vue')),
    Computer: defineAsyncComponent(() => import('@/components/dialog/Computer.vue')),
    ViewTable: defineAsyncComponent(() => import('@/components/dialog/ViewTable.vue')),
    TicketList: defineAsyncComponent(() => import('@/components/dialog/TicketList.vue')),
    MemberDialog: defineAsyncComponent(() => import('@/components/dialog/MemberDialog.vue')),
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    //使用彈窗
    const { dialogVisible, dialogTemplate, dialogName, openDialog, closeDialog } = useDialog();
    //建立清單
    const actionBtns = reactive([
      { label: '電子券', func: 'eTicket' },
      { label: '活動', func: 'openMeal' },
      { label: '旺卡/會員', func: 'queryCard' },
      { label: '開錢櫃', func: 'openMoney' },
      { label: '重新點餐', func: 'restart' },
      { label: '清空列表', func: 'reset' },
      { label: '掛單', func: 'save' },
      { label: '瀏覽', func: 'view' },
    ]);
    // -----------------------------------------------------
    //檢查disable
    const { getStep, getOrderInfo } = useGetters('order', ['getStep', 'getOrderInfo']);
    const getSource = useGetters('order', ['getSource']);
    const getSystem = useGetters('system', ['getSystem']);
    const getCart = useGetters('cart', ['getCart']);

    const checkDisabled = (val) => {
      //隔日需清帳(show type = 2 / 3)鎖旺卡會員
      if (val === 'queryCard' && (getSystem.value?.show_alert_type === 2 || getSystem.value?.show_alert_type === 3))
        return false;
      //旺卡會員和開錢櫃在未建立訂單時開放按鈕，其餘皆鎖
      else if (getStep.value === 1 && val !== 'queryCard' && val !== 'openMoney') return false;
      //購物車無商品時鎖清空/掛單/瀏覽
      else if ((val === 'view' || val === 'reset' || val === 'save') && getCart.value?.length < 1) return false;
      //掛單的單不能按重新點餐
      else if (val === 'restart' && getOrderInfo.value.status === 15) return false;
      else return true;
    };
    //檢查有沒有資訊
    const { getMemberInformation, getDayungsPayment, getVoucherList, getCouponList } = useGetters('member', [
      'getMemberInformation',
      'getDayungsPayment',
      'getVoucherList',
      'getCouponList',
    ]);
    const checkInfo = (val) => {
      //旺卡會員
      if (val === 'queryCard' && (getDayungsPayment.value || getMemberInformation.value)) return true;
      //電子券
      else if (val === 'eTicket' && (getVoucherList.value?.length > 0 || getCouponList.value?.length > 0)) return true;
    };
    // -----------------------------------------------------
    //執行點擊
    const handleClick = (event) => {
      proxy[event]();
    };
    // -----------------------------------------------------
    //電子卷
    const doQueryTicket = useActions('member', ['doQueryTicket']);
    const eTicket = async () => {
      try {
        if (getVoucherList.value?.length > 0 || getCouponList.value?.length > 0) openDialog('ticketList');
        else {
          openDialog('noticeScan', { scanType: 6 }, { dialogContent: `請感應/掃描電子券` });
          await doQueryTicket();
          closeDialog();
        }
      } catch (error) {
        closeDialog();
      }
    };
    //選擇電子券活動
    let selectTicketEvent ;
    const openMeal = () => {
      selectTicketEvent = null;
      openDialog('selectTicketEvent');
    };
    const doUseTicket = useActions('member', ['doUseTicket']);
    const handleSelectTicketEvent = async (val) => {
      selectTicketEvent = val;
      closeDialog();
      //2025-11-14 調整不用事先選擇數量
      //開啟數量的選擇
      // openDialog('quantity',  {
      //   init: 1,
      // });
      await doUseTicket({ 'ticket_id' : selectTicketEvent.value, 'quantity' : 1});
    };
    const handleQuantity = async (num) => {
      if (num === 0 ) {
        return;
      }
      await doUseTicket({ 'ticket_id' : selectTicketEvent.value, 'quantity' : num});
      closeDialog();
    };

    // -----------------------------------------------------
    //會員 與旺卡合併功能
    // const doQueryMember = useActions('member', ['doQueryMember']);
    // const member = async () => {
    //   try {
    //     if (!getMemberInformation.value) {
    //       openDialog('noticeScan', { scanType: 1 }, { dialogContent: `請感應/掃描<br/>會員卡` });
    //       await doQueryMember();
    //       openDialog('memberInfoFirstTime');
    //     } else {
    //       openDialog('memberInfo');
    //     }
    //   } catch (error) {
    //     closeDialog();
    //   }
    // };
    //加入推薦品項 ------第一版先不上此功能
    // const doAddRecommendItem = useActions('cart', ['doAddRecommendItem']);
    // const addRecommend = async (item) => {
    //   await doAddRecommendItem(item);
    //   closeDialog();
    // };
    //旺卡+會員卡

    const showMemberDialog = ref(false);
    const doCheckMember = useActions('member', ['doCheckMember']);
    const handleMemberChecked = async (phone) => {
      // memberPhone.value = phone;
      // handleCheckDeviceStatus();
      // alert("memberPhone.value =" + phone);
      // await doCheckMember(phone);
      await doCheckMember(phone);
    };

    const doQueryCard = useActions('member', ['doQueryCard']);
    const queryCard = async () => {
      try {
        if (!getDayungsPayment.value && !getMemberInformation.value) {
          const allowedSources = ['on_site', 'phone', 'line'];
          const cusProps = {
            scanType: 1,
            canEnter: allowedSources.includes(getSource.value),
            canEnterText: '電話會員',
          };
          openDialog('noticeScan', cusProps, { dialogContent: `請感應/掃描<br/>旺卡或會員卡`, submitFunc: 'openEnterCode' });
          await doQueryCard();
        }
        openDialog('cardInfo');
      } catch (error) {
        closeDialog();
      }
    };
    //旺卡加值/退值
    const doAddCardVale = useActions('member', ['doAddCardVale']);
    const handleWantCardMoney = async (val) => {
      if (val % 100 !== 0) {
        proxy
          .$message('錯誤提示', `${dialogName.value === 'wantCardAdd' ? '加值' : '退值'}金額須以佰元為單位`)
          .catch((e) => e);
        return false;
      }
      if (dialogName.value === 'wantCardRefund') val = val * -1;
      await doAddCardVale({
        card_no: getDayungsPayment.value.want_card.card_no,
        value: val,
        is_digital_card: getDayungsPayment.value.want_card.is_digital_card,
        member_card_no: getMemberInformation.value?.card_no || '',
      });
      openDialog('completeAddCard');
    };
    const handleCompleteAddCard = () => {
      openDialog('cardInfo');
    };
    //偵測操作的彈窗關閉時要做的動作
    const getOrderId = useGetters('order', ['getOrderId']);
    const { SET_MEMBER, SET_DAYUNGS_PAYMENT } = useMutations('member', ['SET_MEMBER', 'SET_DAYUNGS_PAYMENT']);
    watch([dialogName, dialogVisible], () => {
      //加值旺卡或退值旺卡彈窗關閉後，開啟旺卡會員資訊頁
      if ((dialogName.value === 'wantCardAdd' || dialogName.value === 'wantCardRefund') && !dialogVisible.value) {
        openDialog('cardInfo');
      }
      //未建立訂單時結束旺卡與會員的操作後要清空資料
      if (dialogName.value === 'cardInfo' && !dialogVisible.value && !getOrderId.value) {
        SET_MEMBER(null);
        SET_DAYUNGS_PAYMENT(null);
      }
    });
    //重新掃描旺卡或會員卡
    const reScan = async () => {
      try {
        const allowedSources = ['on_site', 'phone', 'line'];
        const cusProps = {
          scanType: 1,
          canEnter: allowedSources.includes(getSource.value),
          canEnterText: '電話會員',
        };
        openDialog('noticeScan', cusProps, { dialogContent: `請感應/掃描<br/>旺卡或會員卡`, submitFunc: 'openEnterCode' });
        await doQueryCard();
        openDialog('cardInfo');
      } catch (error) {
        closeDialog();
      }
    };

    // -----------------------------------------------------
    //開錢櫃
    const doOpenCashBox = useActions('system', ['doOpenCashBox']);
    const openMoney = () => {
      doOpenCashBox();
    };

    //打開手動輸入
    const openEnterCode = () => {
      const isPhoneMember = store.getters['member/isPhoneMember'];
      const memberId = store.getters['member/getMemberId'];
      console.log(`isPhoneMember=${isPhoneMember} memberId=${memberId}`);
      // 如果有 MemberId 但不是 phoneMember 代表他是旺卡或是app會員，則不允許輸入
      if (memberId && !isPhoneMember) {
        proxy.$message('提醒', '旺卡或APP會員請無法切換成電話會員');
        return;
      }

      // 如果原先是電話會員，要再輸入，則要判斷他是否有使用優惠券了

      if (isPhoneMember) {
        // 檢查是否有已使用的優惠券
        const hasUsedCoupons = getCouponList.value.some(coupon => checkUsed(coupon.coupon_id));
        const includeCoupon = isIncludeCoupon()
        if (hasUsedCoupons || includeCoupon) {
          proxy.$message('提醒', '已使用優惠券，無法更換電話會員。請先刪除優惠券，或重新建立訂單');
          return;
        }
      }

      showMemberDialog.value = true;
    };
    //檢查票券是否有被使用
    const checkUsed = (code) => {
      return getCart.value.some((e) => e.form_source_code === code);
    };

    //購物車裡面是否包含票券
    const isIncludeCoupon = () => {
      return getCart.value.some((e) => e.item_type === 13);
    }
    // -----------------------------------------------------
    //重新點餐
    const doAbrogateOrder = useActions('order', ['doAbrogateOrder']);
    const restart = () => {
      proxy
        .$confirm({
          content: '將清除所有訂單資訊，是否確定要重新點餐？',
          confirmText: '重新',
        })
        .then(() => {
          doAbrogateOrder();
        })
        .catch((e) => e);
    };
    // -----------------------------------------------------
    //清空列表
    const doClearCart = useActions('cart', ['doClearCart']);
    const reset = () => {
      proxy
        .$confirm({
          content: '是否確定要清空列表？',
          confirmText: '清空',
        })
        .then(() => {
          doClearCart();
        })
        .catch((e) => e);
    };
    // -----------------------------------------------------
    //掛單
    const doPendingEachOrder = useActions('handleOrder', ['doPendingEachOrder']);
    const doRestartOrder = useActions('order', ['doRestartOrder']);
    const save = () => {
      proxy
        .$confirm({
          content: '是否確定要掛單？',
          confirmText: '掛單',
        })
        .then(async () => {
          await doPendingEachOrder();
          doRestartOrder();
        })
        .catch((e) => e);
    };
    // -----------------------------------------------------
    //瀏覽
    const SET_IS_VIEW = useMutations('menuItem', ['SET_IS_VIEW']);
    const view = () => {
      openDialog('view');
      SET_IS_VIEW(true);
    };
    // -----------------------------------------------------
    //交易
    const router = useRouter();
    const payment = () => {
      router.push('/checkout');
    };
    return {
      dialogTemplate,
      actionBtns,
      getStep,
      getCart,
      checkDisabled,
      checkInfo,
      handleClick,
      eTicket,
      openMeal,
      handleSelectTicketEvent,
      handleQuantity,
      queryCard,
      handleWantCardMoney,
      handleCompleteAddCard,
      reScan,
      openMoney,
      restart,
      reset,
      save,
      view,
      payment,
      openEnterCode,
      showMemberDialog,
      handleMemberChecked
    };
  },
};
</script>
<style lang="scss" scoped></style>
